/**
 * @generated SignedSource<<e33f449221faac78bd940e46754da936>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecapTemplateType = "BANT" | "CUSTOMER_SUCCESS" | "MEDDIC" | "SALES_DISCOVERY" | "SALES_FOLLOW_UP" | "SPICED";
export type TranscriptModalGenerateRecapTemplateMutation$variables = {
  meetingRecordingId: string;
  templateType: RecapTemplateType;
};
export type TranscriptModalGenerateRecapTemplateMutation$data = {
  readonly generateRecapTemplate: {
    readonly meetingRecording: {
      readonly isGeneratingRecapTemplate: boolean;
    };
    readonly ok: boolean;
  } | null;
};
export type TranscriptModalGenerateRecapTemplateMutation = {
  response: TranscriptModalGenerateRecapTemplateMutation$data;
  variables: TranscriptModalGenerateRecapTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "meetingRecordingId",
    "variableName": "meetingRecordingId"
  },
  {
    "kind": "Variable",
    "name": "templateType",
    "variableName": "templateType"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGeneratingRecapTemplate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptModalGenerateRecapTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GenerateRecapTemplate",
        "kind": "LinkedField",
        "name": "generateRecapTemplate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranscriptModalGenerateRecapTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GenerateRecapTemplate",
        "kind": "LinkedField",
        "name": "generateRecapTemplate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "40bfd59c2f1c27a0a4605c48017ee9bd",
    "id": null,
    "metadata": {},
    "name": "TranscriptModalGenerateRecapTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptModalGenerateRecapTemplateMutation(\n  $meetingRecordingId: ID!\n  $templateType: RecapTemplateType!\n) {\n  generateRecapTemplate(meetingRecordingId: $meetingRecordingId, templateType: $templateType) {\n    ok\n    meetingRecording {\n      isGeneratingRecapTemplate\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a971b42e0b5f94cdefeaae9cb807c14f";

export default node;
